/**
 * src/components/CopyBlock/CopyBlock.tsx
 *
 * Renders a multi-paragraph string as individual <p> elements.
 * Paragraphs are separated by double newlines (\n\n).
 * Empty segments are filtered out so leading/trailing whitespace doesn't
 * produce blank paragraphs.
 *
 * Accepts a className so it can be styled via styled-components:
 *   const StyledCopy = styled(CopyBlock)`
 *     font-size: 1.5rem;
 *     & > p + p { margin-top: 0.75rem; }
 *   `;
 */

import React from 'react';

interface Props {
  text: string;
  className?: string;
}

export default function CopyBlock({ text, className }: Props) {
  const paragraphs = text.split('\n\n').filter(s => s.trim().length > 0);

  return (
    <div className={className}>
      {paragraphs.map((para, i) => (
        <p key={i}>{para.trim()}</p>
      ))}
    </div>
  );
}
